import React from "react";
import {
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { useLanguage } from "../../context/LanguageContext";

const MtSlider = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { language, translations } = useLanguage();

  const feature = {
    heading: "Trade & Grow with\nBBCorp",
    description:
      "Claim your piece of the world's most successful companies and expand your potential.",
    buttonText: "Start Trading Now",
  };

  return (
    <Box
      sx={{
        px: { xs: 2, md: "6.5rem" },
        py: 3,
      }}
    >
      <Box
        sx={{
          backgroundImage: "url('Images/wealthback.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          py: { xs: 4, md: 6 },
          px: 3,
          borderRadius: "20px",
          textAlign: "center",
          color: "#000",
          border: {
            xs: "none",
            sm: "0.2px solid rgba(36, 148, 201, 0.5)",
          },
          minHeight: { xs: 450, md: 500 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: 2,
            overflow: "hidden",
            mb: 3,
            mx: "auto",
          }}
        >
          <img
            src="Images/ShadowLogo.png"
            alt="Logo"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box>

        {/* Heading */}
        <Typography
          variant={isMobile ? "h5" : "h2"}
          fontWeight={700}
          sx={{ mb: 2 }}
        >
          {feature.heading.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          color="text.secondary"
          maxWidth={600}
          fontWeight={500}
          mx="auto"
          sx={{ mb: 4, mt: 1 }}
        >
          {feature.description}
        </Typography>

        {/* Button */}
        <Button
         href="https://portal.bbcorp.trade/auth/jwt/sign-up/" // ← your actual link here
         target="_blank"
         rel="noopener noreferrer"
          disableRipple
          variant="contained"
          sx={{
            backgroundColor: "rgba(25, 171, 226, 1)",
            borderRadius: "12px",
            textTransform: "none",
            fontWeight: 400,
            boxShadow: "none",
            px: 4,
            py: 1.5,
            "&:hover": {
              backgroundColor: "rgba(25, 171, 226, 1)",
              boxShadow: "none",
              color:"#fff",
            },
            "&:active": {
              boxShadow: "none",
            },
          }}
        >
          {feature.buttonText} &nbsp;
          <EastIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default MtSlider;
